import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MembersService } from 'src/app/shared/services/members.service';
import { DisclaimerService } from 'src/app/shared/services/disclaimer.service';
import { Disclaimer } from 'src/app/shared/models/disclaimer';
import { ModalConfirmationComponent } from 'src/shared-app-portal/components/modal-confirmation/modal-confirmation.component';

import _ from 'lodash';
import moment from 'moment';
import { SeatInvitation } from './seatInvitation';

@Component({
  selector: 'app-invitation',
  templateUrl: './invitation.component.html',
  styleUrls: ['./invitation.component.scss'],
  standalone: false
})
export class InvitationComponent implements OnInit {
  acceptedMessage: string = 'You have accepted your invitation already.';
  declinedMessage: string = 'You have declined your invitation.';
  noShowMessage: string = 'No show after invitation.';
  notFoundMessage: string = 'Your invitation could not be found.';
  seatInvitation: SeatInvitation = new SeatInvitation();
  disclaimers: Disclaimer[] = new Array<Disclaimer>();
  confirmationRef: MatDialogRef<ModalConfirmationComponent>;
  accepted: boolean = false;
  public currentDate;
  declineReason: string = '';

  constructor(
    private membersService: MembersService,
    private disclaimerService: DisclaimerService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private viewContainerRef: ViewContainerRef
  ) {}

  ngOnInit() {
    this.currentDate = moment(new Date());
    this.route.params.subscribe((params) => {
      let personId = params['personId'];
      let seatId = params['seatId'];
      this.getSeatInvitation(personId, seatId);
    });
    this.disclaimerService.disclaimers.subscribe(
      (disclaimers) =>
        (this.disclaimers = disclaimers.filter(
          (x) => x.activeEndDate == null || x.activeEndDate > this.currentDate
        ))
    );
    this.disclaimerService.getDisclaimers();
  }

  getSeatInvitation(personId, seatId) {
    this.membersService.getSeatInvitation(personId, seatId).subscribe((seatInvitation) => {
      this.seatInvitation = seatInvitation;
      this.membersService.workspaceLogoUrl.next(seatInvitation.workspaceLogoUrl);
      this.membersService.workspaceHelpLink.next(seatInvitation.workspaceHelpLink);
    });
  }

  acceptInvitation() {
    let component = this;
    if (!component.allDisclaimersAcknowledged()) return;
    component.openDialog('accept this invitation', 'Accept Invitation', false, function () {
      component.membersService
        .acceptInvitation(
          component.seatInvitation.personId,
          component.seatInvitation.teamId,
          component.seatInvitation.seatId
        )
        .subscribe((response) => (component.accepted = true));
    });
  }

  declineInvitation() {
    let component = this;
    component.openDialog('decline this invitation', 'Decline Invitation', true, (result) => {
      component.membersService
        .declineInvitation(
          component.seatInvitation.personId,
          component.seatInvitation.teamId,
          component.seatInvitation.seatId,
          typeof result === 'string' ? result : null
        )
        .subscribe((response) => (component.seatInvitation.status = 'Declined'));
    });
  }

  openDialog(action: string, buttonText: string, decline: boolean, successCallback: any) {
    this.confirmationRef = this.dialog.open(ModalConfirmationComponent, {
      viewContainerRef: this.viewContainerRef,
      data: { action: action, okButtonText: buttonText, delete: decline }
    });

    this.confirmationRef.afterClosed().subscribe((result) => {
      if (result) {
        successCallback(result);
      }
      this.confirmationRef = null;
    });
  }

  downloadDisclaimer(disclaimer: Disclaimer) {
    if (disclaimer.hasDownloadableFile) {
      this.disclaimerService.getDownloadUrl(disclaimer.id).subscribe((result) => {
        if (result) window.open(result.url, '_blank');
      });
    }
  }

  getMessage() {
    switch (this.seatInvitation.status) {
      case undefined:
        return '';
      case 'Invited':
        return this.invitedMessage();
      case 'NoResponse':
        return this.noResponseMessage();
      case 'Accepted':
        return this.acceptedMessage;
      case 'Declined':
        return this.declinedMessage;
      case 'NoShow':
        return this.noShowMessage;
      default:
        return this.notFoundMessage;
    }
  }

  invitedMessage() {
    return `You've been invited to ${
      this.seatInvitation.publicTeamName
        ? this.seatInvitation.publicTeamName
        : this.seatInvitation.teamName
    }.`;
  }

  noResponseMessage() {
    return `You've not responded to ${
      this.seatInvitation.publicTeamName
        ? this.seatInvitation.publicTeamName
        : this.seatInvitation.teamName
    }.`;
  }

  allDisclaimersAcknowledged() {
    return _.every(this.disclaimers, function (disclaimer) {
      return disclaimer.isAcknowledged;
    });
  }
}
